import React from 'react';
/**
 * Custom radio field, structured in a
 * after ibok's layout. Gives a simple container
 * for both the input value and the label
 * */
var CustomRadioInput = function (props) {
    var _a = props.isChecked, isChecked = _a === void 0 ? false : _a, name = props.name, inputLabel = props.inputLabel, inputValue = props.inputValue, hint = props.hint, onBlur = props.onBlur, onChange = props.onChange, _b = props.required, required = _b === void 0 ? false : _b;
    return React.createElement("div", { className: "field-radio " + (isChecked ? 'field-radio--checked' : ''), title: hint },
        React.createElement("label", { htmlFor: inputValue, className: "label-radio" }, inputLabel),
        React.createElement("input", { className: "input-radio", type: "radio", name: name, onChange: onChange, onBlur: onBlur, value: inputValue, checked: isChecked, id: inputValue, required: required }));
};
export default CustomRadioInput;
